import { createSlice } from '@reduxjs/toolkit';
import { handleLogin, handleLogout } from './asyncThunk';

// ------ Authentication --------
const userInitialState = {
  token: null,
  tokenType: undefined,
  redirectAuth: undefined,
  tokenValidate: null,
  isAuthenticated: true,
  errorMessages: [],
  message: undefined,
  isCheckingAuth: false,
  authTimeLeftVisibility: true,
  authTimeLeftOverflow: false,
  authCredentials: true,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: userInitialState,
  reducers: {
    login: (state, { payload }) => {
      const { token, isAuthenticated } = payload;
      return {
        ...state,
        token,
        isAuthenticated,
      };
    },
    logout: (state) => {
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        isCheckingAuth: false,
      };
    },
    checkingCredentials: (state) => {
      return {
        ...state,
        isCheckingAuth: true,
      };
    },
    resetToken: (state) => {
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        isCheckingAuth: false,
      };
    },

    loadTokenToStore: (state, { payload }) => {
      const { token, isAuthenticated } = payload;
      return {
        ...state,
        token,
        isAuthenticated,
        isCheckingAuth: false,
      };
    },

    finishLoad: (state) => {
      return {
        ...state,
        isCheckingAuth: false,
      };
    },

    setRedirectAuthPath: (state, { payload }) => {
      return {
        ...state,
        redirectAuthPath: payload.redirectAuthPath,
      };
    },

    setTimeLeftVisibility: (state, { payload }) => {
      return {
        ...state,
        authTimeLeftVisibility: payload.authTimeLeftVisibility,
      };
    },

    setTimeLeftOverflow: (state, { payload }) => {
      return {
        ...state,
        authTimeLeftOverflow: payload.authTimeLeftOverflow,
      };
    },

    setCredentialStatus: (state, { payload }) => {
      return {
        ...state,
        authCredentials: payload.authCredentials,
      };
    },
  },
  extraReducers: {
    [handleLogin.pending]: (state) => {
      return {
        ...state,
        isCheckingAuth: true,
        errorMessages: [],
      };
    },

    [handleLogin.fulfilled]: (state, { payload }) => {
      const { token } = payload;
      return {
        ...state,
        isCheckingAuth: false,
        errorMessages: [],
        isAuthenticated: true,
        token,
      };
    },

    [handleLogin.rejected]: (state, { payload }) => {
      return {
        ...state,
        isCheckingAuth: false,
        errorMessages: payload,
        isAuthenticated: false,
        token: null,
      };
    },

    [handleLogout.fulfilled]: (state) => {
      return {
        ...state,
        isAuthenticated: false,
        errorMessages: [],
        token: null,
      };
    },

    [handleLogout.rejected]: (state) => {
      return {
        ...state,
        isAuthenticated: false,
        errorMessages: [],
        token: null,
      };
    },
  },
});

export default authSlice.reducer;
export const {
  login,
  logout,
  checkingCredentials,
  resetToken,
  loadTokenToStore,
  finishLoad,
  setTimeLeftVisibility,
  setTimeLeftOverflow,
  setCredentialStatus,
} = authSlice.actions;
